/**
 * Central fetch dispatcher: handlers register with priority; one outermost window.fetch at install.
 * Passthrough uses luxNativeFetch (chain below dispatcher, e.g. P&L / Kontensalden patches).
 */
const luxFetchHandlers = []

let luxNativeFetch = null

function luxRegisterFetchHandler(handler) {
  if (!handler?.id || typeof handler.match !== 'function' || typeof handler.handle !== 'function') {
    throw new Error('luxRegisterFetchHandler: handler needs id, match, handle')
  }
  const priority = Number.isFinite(handler.priority) ? handler.priority : 100
  luxFetchHandlers.push({ ...handler, priority })
  luxFetchHandlers.sort((a, b) => a.priority - b.priority)
}

function luxBuildFetchContext(args) {
  const isStringUrl = typeof args[0] === 'string'
  const url = (isStringUrl ? args[0] : args[0]?.url) || ''
  const method = ((isStringUrl ? args[1]?.method : args[0]?.method) || 'GET').toUpperCase()
  return {
    args,
    isStringUrl,
    url,
    method,
    pathname: window.location.pathname,
  }
}

function luxInstallFetchDispatcher() {
  if (window.__luxFetchDispatcherInstalled) return

  luxNativeFetch = window.fetch.bind(window)
  window.luxNativeFetch = luxNativeFetch
  window.__luxFetchDispatcherInstalled = true

  window.fetch = function luxDispatchFetch(...args) {
    const ctx = luxBuildFetchContext(args)

    for (const handler of luxFetchHandlers) {
      if (!handler.match(ctx)) continue
      const result = handler.handle(ctx, luxNativeFetch)
      if (result !== null && result !== undefined) {
        return result
      }
    }

    return luxNativeFetch.apply(this, args)
  }
}
